import * as React from 'react';
import {useDispatch} from 'react-redux';
import {ajax} from 'rxjs/ajax';
import {
    PDF_EXTENSION,
    PDF_MIME_TYPE,
} from '../../../../../common/constants/MimeTypeConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {downloadFileFromURL} from '../../../../../common/utils/GeneralUtils';
import {getFileName, isImage} from '../../../../../common/utils/UrlUtils';
import {bytesToHumanFileSize} from '../../../../../common/utils/Utils';
import * as ModalActions from '../../../../../common/actions/ModalActions';
import * as AWS from '../../../../constants/AWSConstants';
import {Creators as ChatDataActions} from '../../../reducers/chat/data';

interface ChatsShowMediaViewProps {
    data: {
        url: string;
        messageId: string;
    };
}
const getImageInfo = (url) =>
    ajax({
        method: 'HEAD',
        url: url.replace(
            `${AWS.BUCKET_HOSTNAME_S3}/${AWS.BUCKET_NAME}`,
            AWS.BUCKET_HOSTNAME_CDN,
        ),
    });

const ChatsShowMediaView: React.FC<ChatsShowMediaViewProps> = ({
    data: {url, messageId},
}): React.ReactElement => {
    const dispatch = useDispatch();
    const onDownload = () => {
        const type = url.indexOf(PDF_EXTENSION) >= 0 ? PDF_MIME_TYPE : '';
        return downloadFileFromURL(url, getFileName(url), type);
    };
    const onDelete = (evt) => {
        evt.preventDefault();
        dispatch(ChatDataActions.deleteChatDocument(messageId, url));
        dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
    };
    const [fileType, setFileType] = React.useState(null);
    const [fileSize, setFileSize] = React.useState(null);
    const [showConfirmDeletion, setShowConfirmDeletion] = React.useState(false);
    React.useEffect(() => {
        const subscription = getImageInfo(url).subscribe(
            (res) => {
                setFileType(res.xhr.getResponseHeader('content-type'));
                setFileSize(
                    bytesToHumanFileSize(
                        res.xhr.getResponseHeader('content-length'),
                    ),
                );
            },
            (err) => console.log('[ERROR]', err),
        );
        return () => {
            subscription.unsubscribe();
        };
    }, []);
    return (
        <div className="container px-0">
            <div className="row">
                <div className="col-12 d-flex justify-content-center">
                    {isImage(url) ? (
                        <img
                            className="max-h-60-screen img-fluid pb-3"
                            src={url}
                        />
                    ) : (
                        <div className="pdf-wrapper mb-4">
                            <object
                                className="pdf-object"
                                data={`${url}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0`}
                            />
                        </div>
                    )}
                </div>
                <div className="col-12 d-flex justify-content-center pt-0 pb-4">
                    <div className="list-group list-group-flush w-75 small">
                        <div className="row">
                            <div className="col-2 font-weight-bold">nombre</div>
                            <div className="col-10">{getFileName(url)}</div>
                        </div>
                        <div className="row py-1">
                            {fileType && (
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-4 font-weight-bold">
                                            tipo
                                        </div>
                                        <div className="col-8">{fileType}</div>
                                    </div>
                                </div>
                            )}
                            <div className="col-6">
                                <div
                                    className="row chat-actions"
                                    onClick={onDownload}>
                                    <div className="col-4 font-weight-bold">
                                        descargar
                                    </div>
                                    <div className="col-8">
                                        <img
                                            src={AssetsManager(
                                                '/assets/images/common/upload-file.svg',
                                            )}
                                            alt="descargar"
                                            width="22px"
                                            height="22px"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {fileSize && (
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-4 font-weight-bold">
                                            tamaño
                                        </div>
                                        <div className="col-8">{fileSize}</div>
                                    </div>
                                </div>
                            )}
                            <div className="col-6">
                                {showConfirmDeletion ? (
                                    <div className="row">
                                        <div className="col-12 text-primary">
                                            ¿Eliminar Documento?
                                            <a
                                                href="#"
                                                className="btn btn-primary btn-sm ml-3 mr-1"
                                                onClick={onDelete}>
                                                SI
                                            </a>
                                            <a
                                                href="#"
                                                className="btn btn-light btn-sm"
                                                onClick={(evt) => {
                                                    evt.preventDefault();
                                                    setShowConfirmDeletion(
                                                        false,
                                                    );
                                                }}>
                                                NO
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        className="row chat-actions"
                                        onClick={() =>
                                            setShowConfirmDeletion(true)
                                        }>
                                        <div className="col-4 font-weight-bold">
                                            eliminar
                                        </div>
                                        <div className="col-8">
                                            <img
                                                src={AssetsManager(
                                                    '/assets/images/common/deletable-icon.svg',
                                                )}
                                                alt="descargar"
                                                width="22px"
                                                height="22px"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatsShowMediaView;
